import { Tab as SDTab, type TabProps as SDTabProps } from '@smiledragon-corp/sds-system/components';
import { useTheme } from '@smiledragon-corp/sds-system/system';
import { getColorValue } from '@smiledragon-corp/sds-system/utils';

type BaseTabProps = Omit<SDTabProps, 'variant'>;
type SegmentTypeTabProps = {
  colorVariant?: 'primary' | 'gray';
  isRound?: boolean;
  variant: 'segment';
} & BaseTabProps;
type DefaultTypeTabProps = {
  variant: Exclude<SDTabProps['variant'], 'segment'>;
} & BaseTabProps;

type TabProps = SegmentTypeTabProps | DefaultTypeTabProps;

export const Tab = (props: TabProps) => {
  const theme = useTheme();

  const activeStyle = (() => {
    if (props.variant !== 'segment') return undefined;
    const { isRound, colorVariant = 'primary' } = props;
    return {
      background: 'none',
      backgroundColor: getColorValue('bg.interactive.primary', theme),
      ...(isRound && { borderRadius: 999 }),
      ...(colorVariant === 'gray' && {
        backgroundColor: getColorValue('bg.primary', theme),
        color: getColorValue('text.primary', theme),
      }),
    };
  })();

  return (
    <SDTab
      {...props}
      {...(props.variant === 'segment' && { activeStyle })}
      {...(props.variant === 'segment' &&
        props?.isRound && {
          styleComponents: {
            ...props.styleComponents,
            wrapper: {
              ...props.styleComponents?.wrapper,
              css: {
                borderRadius: 999,
              },
            },
          },
        })}
    />
  );
};
